import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IUploadedImageAsset } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createSpaceAsset: {
    asset: IUploadedImageAsset
  }
}

const mutateHandler = handleFetchResult<IPayload, IUploadedImageAsset>({
  handler: (data) => data.createSpaceAsset.asset,
  name: 'Upload asset',
})

export default function createSpaceAsset(input: {
  content: string
  fileName: string
  isDefault: boolean
  space_id: string
}): Promise<IUploadedImageAsset> {
  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(mutateHandler)
}

const mutation = gql`
  mutation createSpaceAsset($input: CreateSpaceAssetInput!) {
    createSpaceAsset(input: $input) {
      asset {
        id
        url
        fileName
        updatedAt
        isDefault
      }
    }
  }
`
